var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.loginshow)?_c('div',[_c('PopupsLogin')],1):_vm._e(),(_vm.bindshow)?_c('div',[_c('OtherLogin',{staticClass:"login_btn",attrs:{"type":"wx"}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }